import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle, ArrowRight } from 'lucide-react';
export function Slide06OpenQuestions() {
  const questions = ['How do we handle out-of-stock ingredients for auto-planned meals?', 'What is the fallback if the AI generates a plan the user hates?', 'Do we enforce a minimum cart size for auto-checkout?', "How transparent should we be about the AI's selection criteria?"];
  return <div className="w-full h-full flex flex-col justify-center px-[clamp(4rem,8vw,10rem)]" data-id="element-201">
      <div className="max-w-4xl" data-id="element-202">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-12" data-id="element-203">
          <span className="text-[var(--accent)] font-semibold tracking-widest uppercase text-sm mb-4 block" data-id="element-204">
            Next Steps
          </span>
          <h2 className="font-display text-[clamp(3rem,4vw,4.5rem)] leading-tight mb-6" data-id="element-205">
            Open Questions & Risks
          </h2>
          <p className="text-xl text-[var(--fg-muted)]" data-id="element-206">
            Areas we need to de-risk before moving to high-fidelity design.
          </p>
        </motion.div>

        <div className="space-y-6 mb-16" data-id="element-207">
          {questions.map((q, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2 + i * 0.1
        }} className="flex items-start gap-4 p-6 bg-[var(--surface)] rounded-2xl border border-[var(--surface-alt)]" data-id="element-208">
              <HelpCircle className="text-[var(--accent)] shrink-0 mt-1" size={24} data-id="element-209" />
              <p className="text-lg font-medium" data-id="element-210">{q}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6
      }} className="flex items-center gap-6" data-id="element-211">
          <button className="px-8 py-4 bg-[var(--fg)] text-[var(--bg)] rounded-full font-semibold flex items-center gap-2 hover:bg-[var(--fg-muted)] transition-colors" data-id="element-212">
            View Full PRD <ArrowRight size={20} data-id="element-213" />
          </button>
          <span className="text-[var(--fg-muted)] font-medium" data-id="element-214">
            Targeting Eng Review by Friday
          </span>
        </motion.div>
      </div>
    </div>;
}